import React from "react";

const CPP_Enums = () => {
  return (
    <div>
      <h1>CPP_Enums Component</h1>
      <p>Content for CPP_Enums goes here...</p>
    </div>
  );
};

export default CPP_Enums;
